<template>
    <div class="row">
        <div class="col-sm-4">
            <multiselect
                v-model="artefactType"
                :options="artefactTypeOptions"
                label="name"
                placeholder="Eser Tipi"
                @select="artefactTypeSelect"
            >
            </multiselect>
        </div>
        <div class="col-sm-8">
            <multiselect
                v-model="artefact"
                :options="artefactOptions"
                label="title"
                placeholder="Eser"
                select-label="Eser seç"
                @search-change="search"
                @open="open"
                :disabled="artefactType === null"
                @select="select(index)"
            >
                <template slot="afterList" slot-scope="props">
                    <li
                        class="load-more"
                        v-if="!isLoading && artefactOptions.length > 0"
                        @click="loadMore"
                    >
                        Daha Fazla
                    </li>
                    <li v-else-if="isLoading && artefactOptions.length > 0">
                        Yükleniyor...
                    </li>
                </template>
                <template slot="noOptions">
                    <li v-if="isLoading">Yükleniyor...</li>
                    <li v-else>Sonuç Bulunamadı</li>
                </template>
                <template slot="noResult">
                    <li v-if="isLoading">Yükleniyor...</li>
                    <li v-else>Sonuç Bulunamadı</li>
                </template>
            </multiselect>

            <template v-if="createHiddenInput">
                <input
                    v-if="artefact && artefactType"
                    :name="artefactInputName"
                    type="hidden"
                    :value="artefact._id"
                />
                <input
                    v-if="artefact && artefactType"
                    :name="artefactTypeInputName"
                    type="hidden"
                    :value="artefactType.value"
                />
            </template>
        </div>
    </div>
</template>
<script type="javascript">
import Multiselect from 'vue-multiselect'
import axios from 'axios'
import _ from 'lodash'

export default {
    name: 'ArtefactSelect',
    components: { Multiselect },
    props: ['artefactTypeInputName', 'artefactInputName', 'selectedArtefactType', 'selectedArtefact', 'createHiddenInput', 'index'],
    data() {
        return {
            artefactType: null,
            artefact: null,
            axios: axios,
            artefactOptions: [],
            artefactTypeOptions: [
                { name: 'Nesne', value: 'Item' }
            ],
            loadMoreOffset: 1,
            searchQuery: '',
            isLoading : false,
        }
    },
    methods: {
        artefactTypeSelect(artefactType){
            this.artefact = null
            this.reset();
            this.loadArtefactOptions(artefactType.value, 1)
        },
        open(){
            this.reset();
            this.loadArtefactOptions(this.artefactType.value, 1)
        },
        select(index){
            this.$emit('update-artefact', {
                artefactType:this.artefactType.value,
                artefact: {
                    title: this.artefact.title,
                    _id: this.artefact.id,
                }
            }, index)
        },
        loadArtefactOptions(artefactType, page) {
            this.isLoading = true
            return new Promise((resolve,reject) => {
                let body = {}

                if(this.searchQuery !== ''){
                 body = { filters : [
                     { field: 'title', value: this.searchQuery }
                 ]}
                }

                axios.post(`/searchArtefact/${artefactType}/${page}`, body).then(function (response) {
                    response.data.forEach((item) => {
                        this.artefactOptions.push(item)

                    })
                    this.isLoading = false
                    resolve()
                }.bind(this)).catch((e) => {
                    this.isLoading = false
                    reject(e)
                })
            })
        },
        search: _.debounce(function(query) {
            this.searchQuery = query
            this.reset()
            this.loadArtefactOptions(this.artefactType.value, 1)
        }, 500),

        loadMore() {
            this.loadMoreOffset = this.loadMoreOffset + 1
            this.loadArtefactOptions(this.artefactType.value, this.loadMoreOffset)
        },
        reset(){
            this.artefactOptions = [];
            this.loadMoreOffset = 1;
        }
    },
    mounted(){
        if(this.selectedArtefactType){
            this.artefactType = this.artefactTypeOptions.find((option)=>{
                return option.value === this.selectedArtefactType
            })
        }

        if(this.selectedArtefact){
            this.artefact = this.selectedArtefact
        }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// resources/vue/artefact-select.vue